import React from 'react';
import MessagesTable from './SupportMessages/MessagesTable.js';
import AlertsMap from './alerts/AlertsMap.js';

/** Layout du contenu */
export default () => {
  return (
    <div className="dashboard-view">
        <AlertsMap>
          <MessagesTable/>
        </AlertsMap>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Dashboard.js